import { useEffect, useState } from "react";
import AppLayout from "@/components/layout/AppLayout";
import { apiPrivate } from "@/lib/api";
import { Bell, CheckCheck } from "lucide-react";

export default function Notifiche() {
    const [items, setItems] = useState([]);

    const reload = () => apiPrivate.get("/notifications").then(r => setItems(r.data));
    useEffect(() => { reload(); }, []);

    const markRead = async (id) => {
        await apiPrivate.patch(`/notifications/${id}/read`);
        reload();
    };
    const markAll = async () => {
        await apiPrivate.post("/notifications/mark-all-read");
        reload();
    };

    return (
        <AppLayout>
            <div className="max-w-3xl mx-auto" data-testid="notifiche-page">
                <div className="flex items-end justify-between gap-4 flex-wrap">
                    <div>
                        <span className="label-tag">— Centro notifiche</span>
                        <h1 className="font-display text-5xl mt-3 tracking-tighter">Le tue <span className="font-serif-italic text-acid">comunicazioni</span>.</h1>
                    </div>
                    <button onClick={markAll} className="btn-ghost" data-testid="notif-mark-all">
                        <CheckCheck className="h-4 w-4" /> Segna tutte lette
                    </button>
                </div>

                <div className="mt-10 space-y-2" data-testid="notif-list">
                    {items.length === 0 && (
                        <div className="bento p-10 text-center text-zinc-500" data-testid="notif-empty">Nessuna notifica.</div>
                    )}
                    {items.map(n => (
                        <div key={n.id} className={`bento p-5 flex items-start gap-4 ${n.read ? "" : "border-acid"}`} data-testid={`notif-${n.id}`}>
                            <div className={`h-2 w-2 mt-2 rounded-full ${n.read ? "bg-zinc-700" : "bg-acid"}`} />
                            <div className="flex-1 min-w-0">
                                <div className="flex items-center gap-2 flex-wrap">
                                    <span className="font-grotesk font-medium">{n.title}</span>
                                    <span className="label-tag">{n.type}</span>
                                </div>
                                <div className="text-zinc-400 text-sm mt-1">{n.body}</div>
                                <div className="text-zinc-600 text-xs mt-2 font-grotesk uppercase tracking-widest">{new Date(n.created_at).toLocaleString("it-IT")}</div>
                            </div>
                            {!n.read && (
                                <button onClick={() => markRead(n.id)} className="text-xs uppercase tracking-widest font-grotesk text-acid hover:text-white" data-testid={`mark-read-${n.id}`}>Segna letta</button>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </AppLayout>
    );
}
